import { render, staticRenderFns } from "./rede-servicos-direitos-humanos.vue?vue&type=template&id=763a6561&"
import script from "./rede-servicos-direitos-humanos.vue?vue&type=script&lang=js&"
export * from "./rede-servicos-direitos-humanos.vue?vue&type=script&lang=js&"
import style0 from "./rede-servicos-direitos-humanos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports